import React, { useState } from 'react';
import { Button, Form, Input, Radio, DatePicker, Avatar, InputNumber } from 'antd';
import PaymentMethod from '../../components/paymentMethod';
import Title from 'antd/es/typography/Title';
import {
  CreditCardFilled,
  UserOutlined,
} from '@ant-design/icons';
import SelectCategory from '../../components/selectCategory';
import SelectUser from '../../components/selectUser';
import PaymentMethods from '../../enums/payment_methods';
import { openNotification } from '../../components/notifications';
import apiClient from '../../apis/ApiInterceptor';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const CashBox = () => {
  const [showBill, setShowBill] = useState(false);
  const [showUser, setShowUser] = useState(true);
  const [form] = Form.useForm();
  const [maxDate, setMaxDate] = useState(null);

  const handleTransactionTypeChange = (transactionType) => {
    const value = transactionType.target.value;
    setShowBill(value === "0");
    if (value === "1") {
      setMaxDate(dayjs.utc()); // Set max date as today
      const selectedDate = form.getFieldValue('date');
      if (selectedDate && selectedDate.isAfter(dayjs.utc(), 'day')) {
        form.setFieldValue('date', null); // Clear if future date
      }
    } else {
      setMaxDate(null); // No max date
    }
  };

  const handlePaymentMethodChange = (paymentMethodId) => {
    if(paymentMethodId === PaymentMethods.ACCOUNT_PAYABLE){
      setShowUser(false);
      form.setFieldValue('user', undefined);
    }else{
      setShowUser(true);
      form.setFieldValue('owed_person', undefined);
    }
  };

  const onFinish = async (values) => {
    try {
      if (values.date) {
        values.date = values.date.format('YYYY-MM-DD');
      }
      values.petty_cash = 1;
      values.amount_in_cents = values.amount * 100;
      const response = await apiClient.post('/payments', values);
      if(response.status === 201){
        openNotification(
          "success",
          "",
          "Transacción registrada exitosamente."
        );  
        form.resetFields();
      }else{
        console.log('Respuesta del servidor:', response.data);
      }
    } catch (error) {
      console.error('Error al registrar la transacción:', error);
      openNotification(
        "error",
        "",
        "Hubo un error al registrar la transacción."
      );  
    }
  };

  return (
    <Form
      form={form}
      name="validateOnly"
      className="mobile-block themed-block p-3"
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish} 
    >
      <Title level={2} className="text-center">Registrar Transacción</Title>
      <div className="input-group col-10 col-md-5 p-0 mx-auto mt-3">
        <div className="w-75 m-auto text-center">
          <Form.Item
            name="transactionType"
            rules={[{ required: true, message: 'Por favor selecciona el tipo de transacción' }]}
          >
            <Radio.Group onChange={handleTransactionTypeChange}>
              <Radio value="1"> Ingreso </Radio>
              <Radio value="0"> Egreso </Radio>
            </Radio.Group>
          </Form.Item>
        </div>
      </div>
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <CreditCardFilled className="icons" />
        <div className="w-75">
          <Form.Item
            name="paymentMethod"
            className="m-0"
            rules={[{ required: true, message: 'Por favor selecciona el método de pago' }]}
          >
            <PaymentMethod
              showBill={showBill}
              className="w-100"
              onChange={(value) => {
                form.setFieldValue('paymentMethod', value);//The component call this onChange funtion to reset the value
                handlePaymentMethodChange(value);
              }}
            />
          </Form.Item>
        </div>
      </div>
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <i className="fas fa-dollar-sign icons"></i>
        <div className="w-75">
          <Form.Item
            name="amount"
            className="m-0"
            rules={[{ required: true, message: 'Por favor ingresa el valor pagado' }]}
          >
            <InputNumber
              className="w-100"
              min={0}
              placeholder="Valor Pagado"
              formatter={value =>
                value
                  ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  : ''
              }
              parser={value => value ? value.replace(/\./g, '') : ''}
            />
          </Form.Item>
        </div>
      </div>
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <i className="fas fa-calendar-day icons"></i>
        <div className="w-75">
          <Form.Item
            name="date"
            className="m-0"
            rules={[{ required: true, message: 'Por favor selecciona el día de pago' }]}
          >
            <DatePicker              
              placeholder="Día de pago"
              className="w-100"
              disabledDate={maxDate ? (current) => current && current > maxDate.endOf('day') : () => false}
            />
          </Form.Item>
        </div>
      </div>
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <CreditCardFilled className="icons" />
        <div className="w-75">
          <Form.Item
            name="category"
            className="m-0"
            rules={[{ required: true, message: 'Por favor selecciona una categoría' }]}
          >
            <SelectCategory className="w-100" />
          </Form.Item>
        </div>
      </div>
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <i className="fa fa-comments icons"></i>
        <div className="w-75">
          <Form.Item
            name="item"
            className="m-0"
            rules={[{ required: true, message: 'Por favor describe el Item' }]}
          >
            <Input placeholder="Item" className="w-100" />
          </Form.Item>
        </div>
      </div>
      {showUser && (
        <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
          <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<UserOutlined />} />
          <div className="w-75">
            <Form.Item
              name="user"
              className="m-0"
              rules={[{ required: true, message: 'Por favor selecciona el usuario' }]}
            >
              <SelectUser className="w-100" />
            </Form.Item>
          </div>
        </div>
      )}
      {!showUser && (
        <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
          <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<UserOutlined />} />
          <div className="w-75">
            <Form.Item name="owed_person" className="m-0"
              rules={[{ required: true, message: 'Por favor dinos a quién se le debe' }]}
            >
              <Input placeholder="¿A quién se debe?" className="w-100" />
            </Form.Item>
          </div>
        </div>
      )}
      <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
        <Form.Item className='mx-auto my-3'>
          <Button type="primary" className='themed-btn' htmlType="submit">
            Registrar
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default CashBox;
